import React, { useState, useEffect } from 'react';
import { getEmailValidationError } from '../utils/validation';

interface ValidatedEmailInputProps {
  value: string;
  onChange: (value: string) => void;
  onValidChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  id?: string;
  name?: string;
  title?: string;
  style?: React.CSSProperties;
}

export const ValidatedEmailInput: React.FC<ValidatedEmailInputProps> = ({
  value,
  onChange,
  onValidChange,
  disabled,
  required,
  placeholder = "user@example.com",
  id,
  name,
  title,
  style
}) => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const errorMessage = getEmailValidationError(value);
    setError(errorMessage);
    if (!errorMessage && value.trim() !== '') {
      onValidChange(value);
    }
  }, [value, onValidChange]);

  return (
    <div style={{ position: 'relative', ...(style || { width: '100%' }) }}>
      <input
        className={`sky-field-input${error ? ' sky-field-error' : ''}`}
        id={id}
        name={name}
        type="email"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        title={title}
        style={{ width: '100%', paddingRight: error ? 28 : undefined }}
      />
      {error && (
        <span style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', color: 'var(--red)', fontSize: 12, cursor: 'help' }} title={error}>✗</span>
      )}
    </div>
  );
};
